export default {
  OUR_CONSULTANTS: 'ourConsultants',
  OUR_FRANCHISE_PACKAGE: 'ourFranchisePackage',
  FRANCHISE_FACTS: 'franchiseFacts',
};
